export default __webpack_public_path__ + "static/media/melty-banner.7daa4083.svg";